var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramPlayTabM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0078 0L17 1.95798L25.2218 10L17 18.0372L19.0078 20L29.2325 10L19.0078 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7704 0L24.7675 1.95798L32.9892 10L24.7675 18.0372L26.7704 20L37 10L26.7704 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.209 25.1494H22.2512V42.8468H25.209V25.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.27 25.1494H30.3123V42.8468H33.27V25.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6074 32.0114L23.254 34.8818L24.2092 37.701L32.5626 34.8305L31.6074 32.0114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8897 25.1729H8.5V28.1516H18.8897V25.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.176 26.6621H12.2183V42.8276H15.176V26.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1244 44L35.3169 33.3901L41.8239 24L44.2465 25.7021L38.9554 33.3381L45.5 42.2269L43.1244 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3123 31.877H37.1385V34.8557H44.3123V31.877Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0752 67.2792L33.2755 54.021L28.744 67.2547L25.7379 66.2495L31.7302 48.7452L33.0568 48.7354L34.7313 48.7207L41.0664 66.225L38.0752 67.2792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.609 61.8574L33.4061 59.6836L31.2032 61.8574L33.4061 64.0313L35.609 61.8574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7584 68V48H16.9334V63.4989L22.6077 61.4298L23.7108 64.3717L13.7584 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17501 67.8385H0V48.1621L12.0392 54.7373L3.20979 63.9013L3.17501 63.8669V67.8385ZM3.17501 53.4771V59.3904L6.90651 55.5169L3.17501 53.4771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1395 59.9343L41.0714 49.6033L43.9284 48.2402L47.5556 55.6342L51.1331 48.2451L54 49.5984L49.0015 59.9245L46.1395 59.9343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1207 58.0957H45.9457V67.7598H49.1207V58.0957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "white",
    transform: "translate(8.5 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 20,
    fill: "white",
    transform: "translate(0 48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramPlayTabM);
export default __webpack_public_path__ + "static/media/programPlayTabM.bf6155342b3ba84ed06b93caf1e3c792.svg";
export { ForwardRef as ReactComponent };